import { render } from "./FlipCard.vue?vue&type=template&id=64a2a09b&scoped=true"
import script from "./FlipCard.vue?vue&type=script&lang=js"
export * from "./FlipCard.vue?vue&type=script&lang=js"

import "./FlipCard.vue?vue&type=style&index=0&id=64a2a09b&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-64a2a09b"

export default script